import { onBiometricSetup, onBiometricStatus } from "core/javascriptChannels";
import { useEffect, useState } from "react";
import { BiometricStatus } from "./useBiometricStatus";
import { trackEvents } from "core/monitoring/Events";
import { EventNames } from "core/monitoring/types/enums";

export interface BiometricSetupResponse {
  success: boolean;
  message: string;
}

export const useBiometricSetup = (triggerUpdate?: boolean) => {
  const [responseData, setResponseData] = useState<BiometricSetupResponse>();
  const [setupAction, setSetupAction] = useState<string>();
  const [loading, setLoading] = useState<boolean>();

  useEffect(() => {
    const updateBiometricStatus = async () => {
      setLoading(true);
      try {
        const status = await onBiometricStatus();
        const statusIsEnabled = status === BiometricStatus.enabled;
        const updateResponse = await onBiometricSetup(statusIsEnabled ? false : true);
        if (updateResponse.success) {
          trackEvents(EventNames[statusIsEnabled ? "BIOMETRIC_DISABLED" : "BIOMETRIC_ENABLED"]);
        } else {
          trackEvents(EventNames.BIOMETRIC_SETUP_FAILED, updateResponse);
        }
        setSetupAction(statusIsEnabled ? "disabled" : "enabled");
        setResponseData(updateResponse);
      } catch (error: any) {
        trackEvents(EventNames.BIOMETRIC_SETUP_FAILED, { error });
      } finally {
        setLoading(false);
      }
    };
    if (triggerUpdate) {
      updateBiometricStatus();
    }
  }, [triggerUpdate]);

  return { responseData, setupAction, loading };
};
